import type { ApiSubscriptionView } from '../api';

const SUBSCRIPTION_KEY = 'ef_subscription_v1';
export const SUBSCRIPTION_CHANGED_EVENT = 'ef-subscription-changed';

export function setSubscriptionCache(sub: ApiSubscriptionView | null): void {
  try {
    if (sub) localStorage.setItem(SUBSCRIPTION_KEY, JSON.stringify(sub));
    else localStorage.removeItem(SUBSCRIPTION_KEY);
  } catch {
    /* ignore */
  }
  if (typeof window !== 'undefined') window.dispatchEvent(new Event(SUBSCRIPTION_CHANGED_EVENT));
}

export function getSubscriptionCache(): ApiSubscriptionView | null {
  try {
    const raw = localStorage.getItem(SUBSCRIPTION_KEY);
    return raw ? (JSON.parse(raw) as ApiSubscriptionView) : null;
  } catch {
    return null;
  }
}

const ENTITLEMENT_ALIASES: Record<string, string[]> = {
  'customers.sms.reminders': ['customers.whatsapp.reminders'],
  'settings.integrations.sms': ['settings.integrations.whatsapp'],
};

const SMS_EXPLICIT_ITEMS = new Set(['customers.sms.reminders', 'settings.integrations.sms']);

export function planAllowsItem(itemId: string): boolean {
  const sub = getSubscriptionCache();
  if (!sub) return false;
  if (sub.subscriptionStatus !== 'active' || sub.isExpired) return false;
  if (!sub.plan) return false;

  const mod = itemId.startsWith('master.') ? 'dashboard' : itemId.split('.')[0];
  if (sub.plan.features && mod in sub.plan.features && !sub.plan.features[mod]) return false;

  const items = sub.plan.featureItems || {};
  if (items[itemId]) return true;
  const aliases = ENTITLEMENT_ALIASES[itemId];
  if (aliases && aliases.some((a) => Boolean(items[a]))) return true;

  // SMS must be explicitly enabled on the plan (never inherit from open module).
  if (SMS_EXPLICIT_ITEMS.has(itemId)) return false;

  // Enabling SMS alone must not lock other module capabilities.
  const hasNonSmsConfigured = Object.entries(items).some(
    ([id, on]) => on && !SMS_EXPLICIT_ITEMS.has(id)
  );
  if (!hasNonSmsConfigured) return true;
  return false;
}

export function planAllowsModule(module: string): boolean {
  const effective = module === 'erp' ? 'audit' : module;
  const sub = getSubscriptionCache();
  if (!sub) return true;
  if (sub.subscriptionStatus !== 'active' || sub.isExpired) return false;
  if (!sub.plan) return true;
  return Boolean(sub.plan.features?.[effective]);
}
